import { NodeUserData } from "../core/mdl/NodeUserData";
import { SceneElement } from "../core/mdl/SceneElement";
import { ArticleElement } from "./ArticleElement";
import { ARTICLEELEMENT_NODEDATA_SELECTABLE } from "./Constants";
export class SubArticleElement extends ArticleElement {
    constructor(pMainArticle, pBasketId, pManager, pNode) {
        super(pBasketId, pManager, pNode);
        this.mMainArticle = pMainArticle;
    }
    canTranslate() {
        return (false);
    }
    canRotate() {
        return (false);
    }
    canDelete() {
        return (false);
    }
    canSelect() {
        let tSelectable = super.canSelect();
        if (tSelectable) {
            //check is sub article is selectable
            const tSelData = NodeUserData.GetData(this.mNode, ARTICLEELEMENT_NODEDATA_SELECTABLE);
            if (tSelData != null)
                tSelectable = tSelData;
        }
        return (tSelectable);
    }
    isInstanced() {
        return (this.mMainArticle.isInstanced());
    }
    ensureIsInstanced() {
        return (this.mMainArticle.ensureIsInstanced());
    }
    getMainElement() {
        return (this.mMainArticle);
    }
    getMainArticle() {
        return (this.mMainArticle);
    }
    getParentArticle() {
        return this.getParentElement();
    }
    isMainArticle() {
        return (false);
    }
    isSubArticle() {
        return (true);
    }
    clone(pNewParent) {
        const tClone = new SubArticleElement(undefined, null, this.mMngr, SceneElement.cloneNode(this.mNode, pNewParent));
        tClone.copyDataFrom(this);
        return (tClone);
    }
    //// internal //////////////////////////////////////////////////////////////////////////////
    /** @internal */
    _setMainArticle(pMainArticle) {
        this.mMainArticle = pMainArticle;
    }
}
